module.exports = __webpack_public_path__ + "img/O.009b15c8.png";